export default "__VITE_ASSET__p3Tm2zyG__"